/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

function getTooltip (){
    var tooltipTemplate;
    var observateur;
    var date;
    var statut;
    var cause;
    
    return {
        get : function (){
            tooltipTemplate = "Observé par : "+"<b>"+observateur+"</b></br>Enregistré le : "+"<b>"+date+"</b></br>Statut : "+"<b>"+statut+"</b>";
            if(statut === 'Invalidé' && cause !== ''){
                tooltipTemplate += " ("+cause+")";
            }
            return tooltipTemplate;
        },
        set : function (participant, date_formated, detObs){
            observateur = participant;
            date = date_formated;
            statut = detObs.statut;
            cause = detObs.commentaire;
            switch (statut){
                case 'Douteux' : statut = 'Invalidé';break;
            }
        }
    };
}

document.addEventListener ('DOMContentLoaded', function () {
    (function descriptionArea (){
        var parent = document.getElementById('map_visu');
        var container = document.createElement('DIV');
        var text = 'La carte ci-dessous représente les signalements de frelons réalisés via le <a target="_blank" href="http://frelonasiatique.mnhn.fr/signaler-informations/">formulaire</a> de ce site et leur statut de validation. La validation ou invalidation d’une observation est justifiée dans son statut que vous pouvez apercevoir en cliquant sur son point. Une observation validée sans commentaire ou avec le commentaire « viable » permet de prouver la présence d’une colonie viable et la capacité de l’espèce à survivre sur ce lieu l’année de l’observation. Une observation validée avec un autre commentaire ne le permet pas et peut correspondre à des individus sexués, qui ne prouvent pas la présence d’un nid à proximité. Une observation invalidée correspond à des <a target="_blank" href="http://frelonasiatique.mnhn.fr/identification/">confusions avec d’autres espèces</a> ou à des identifications impossibles.';

        container.classList.add("description-map");
        container.innerHTML = text;
        parent.insertBefore(container, parent.firstChild);
    })();
    
    (function linkToOtherParticipants(){
        var reference = document.getElementById('classement');
        var container = document.createElement('DIV');
        var text = '<a target="_blank" class="searchsubmit site_color" style="float:none;"href="https://inpn.mnhn.fr/espece/cd_nom/433589/tab/sources#sources_2_PERS">Totalité des observateurs</a>';
        var textNode = document.createTextNode(text);
        
        container.classList.add("classement-links");
        container.innerHTML = text;
        insertAfter(container, reference);
    })();
});

function insertAfter(newNode, referenceNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

function getPeriodeObs(){
    return 'lastMonth';
}

